import { useState } from 'react';
import { useHasPermission } from '@/hooks/use-has-permission';
import { HRM_PERMISSIONS } from '@/constant/hr/permissions';
import { ServiceDeskPageShell } from '@/modules/service-desk/shared/components/service-desk-page-shell';
import { BusinessCardApplyDialog } from '../../components/business-card-apply-dialog/business-card-apply-dialog';
import { BusinessCardMyApplications } from '../../components/business-card-my-applications/business-card-my-applications';
import { BusinessCardRequests } from '../../components/business-card-requests/business-card-requests';

export const BusinessCardPage = () => {
  const [isApplyOpen, setIsApplyOpen] = useState(false);
  const canViewRequests = useHasPermission(HRM_PERMISSIONS.BUSINESS_CARD_APPLICATION.VIEW_REQUESTS);
  const canApply = useHasPermission(HRM_PERMISSIONS.BUSINESS_CARD_APPLICATION.APPLY);

  return (
    <>
      <ServiceDeskPageShell
        titleKey="BUSINESS_CARD"
        requestsTabKey="BUSINESS_CARD_REQUESTS"
        canViewRequests={canViewRequests}
        requests={<BusinessCardRequests />}
        mine={<BusinessCardMyApplications />}
        onApply={canApply ? () => setIsApplyOpen(true) : undefined}
      />
      <BusinessCardApplyDialog open={isApplyOpen} onOpenChange={setIsApplyOpen} />
    </>
  );
};
